import './work.css'
import Works from './Works'
import { datauser } from '../../../apicall';

export default function Work() {
  return (
    <div className='workcntr'>
      {datauser.map((item, i) => {
        return (
          <Works key = {i} name = {item.wname} url={item.url} image1={item.images} desc={item.desc} lang={item.lang} />
        )
      })}
    </div>
  )
}
